/** routes where auth-required queries (e.g. company, company plan) should not run */
export const AUTH_DISABLED_PAGES = ["/login", "/signup", "/version"] as const;
